import {resolveSite} from '../../tenant.config.js';

const API_URL = import.meta.env.VITE_API_URL;

// Puts the tenant in the URL so the API's CDN, which caches on URL only and
// ignores Vary: Referer, can't serve one site's response to another.
// The default site is browser-only; server-side callers must pass pageContext.site.
export function withSite(url, site = resolveSite(window.location.hostname)) {
    return `${url}${url.includes('?') ? '&' : '?'}site=${site}`;
}

export default API_URL;
